import { closeToast, showLoadingToast } from 'vant'
import { backToApp } from 'dad-h5-common-js'
import { showToast } from '@/components/Toast/index.js'
import { showTips } from '@/components/Tips/tips.js'
import { showConfirm } from '@/components/Confirm/confirm.js'

export {
  showToast,
  showTips,
  showConfirm,
}

export function showLoading() {
  closeToast()
  return showLoadingToast({
    forbidClick: true,
    loadingType: 'spinner',
    duration: 0,
  })
}

export { closeToast as hideLoading }

export function errorToBack(msg) {
  showConfirm({
    message: msg,
    showCancelButton: false,
    confirmText: 'Back',
    title: 'opps!',
  }).then((confirmed) => {
    if (confirmed) backToApp()
  })
}
